import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class MilitaryServiceStatus extends Enum {
  key!: string;
  value!: string;

  static ACTIVE_DUTY: MilitaryServiceStatus = {
    key: 'active_duty',
    get value(): string {
      return Lang.t('contact.active-duty');
    }
  };

  static HONORABLY_DISCHARGED: MilitaryServiceStatus = {
    key: 'honorably_discharged',
    get value(): string {
      return Lang.t('contact.honorably-discharged');
    }
  };

  static RETIRED: MilitaryServiceStatus = {
    key: 'retired',
    get value(): string {
      return Lang.t('contact.retired');
    }
  };

  static NATIONAL_GUARD_RESERVES: MilitaryServiceStatus = {
    key: 'national_guard_reserves',
    get value(): string {
      return Lang.t('contact.retired-from-service');
    }
  };
}
